class MasonryGallery extends HTMLElement {
  connectedCallback() {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      this._init();
    } else {
      window.addEventListener('load', () => this._init(), { once: true });
    }

    this._onResize = this._debounce(() => {
      this._cleanup();
      this._init();
    }, 250);

    window.addEventListener('resize', this._onResize);
  }

  disconnectedCallback() {
    this._cleanup();
    window.removeEventListener('resize', this._onResize);
  }

  _debounce(fn, ms) {
    let timer;
    return () => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.call(this), ms);
    };
  }

  _cleanup() {
    if (this._mm) {
      this._mm.revert();
      this._mm = null;
    }
    // Clear stale transforms so re-init reads correct scrollHeight
    this.querySelectorAll('.mg-track').forEach((track) => {
      gsap.set(track, { clearProps: 'transform' });
    });
  }

  _init() {
    gsap.registerPlugin(ScrollTrigger);

    const tracks = Array.from(this.querySelectorAll('.mg-track'));
    if (!tracks.length) return;

    // factor: proportion of available (gap-free) travel each column uses
    // scrub: temporal lag — higher = more inertia
    const configs = [
      { factor: 0.40, scrub: 0.80 },
      { factor: 0.68, scrub: 0.28 },
      { factor: 0.54, scrub: 0.55 },
      { factor: 0.82, scrub: 0.14 },
    ];

    this._mm = gsap.matchMedia();
    this._mm.add('(prefers-reduced-motion: no-preference)', () => {
      const viewport = window.innerHeight;

      tracks.forEach((track, i) => {
        const { factor, scrub } = configs[i % configs.length];
        const trackHeight = track.scrollHeight;
        const safeMax = Math.max(0, trackHeight - viewport);
        const travel = Math.min(safeMax, trackHeight * factor);

        if (travel <= 0) return;

        gsap.to(track, {
          y: -travel,
          ease: 'none',
          scrollTrigger: {
            trigger: this,
            start: 'top top',
            end: 'bottom bottom',
            scrub,
          },
        });
      });
    });
  }
}

customElements.define('masonry-gallery', MasonryGallery);
